/**
 * TableHint
 * SPで横スクロールする表（導入フローの役割分担表／PDCA表）に、
 * スワイプを促すヒントアイコンを重ねる。最初に横スクロールしたら消す。
 * PCは表がinnerに収まりスクロール不要なため、ヒント自体をCSSで非表示。
 *
 * @example
 * <div class="p-flow-table-wrap js-table-hint">
 *   <div class="p-flow-table-scroll"><table>…</table></div>
 *   <span class="p-flow-table-hint"><img src="…ico_table_scroll.png" alt=""></span>
 * </div>
 */
export default class TableHint {
  constructor(options = {}) {
    const selector = options.selector || '.js-table-hint';
    this.wraps = document.querySelectorAll(selector);
    if (!this.wraps.length) return;

    this.wraps.forEach((wrap) => {
      const scroller = wrap.querySelector('.p-flow-table-scroll');
      if (!scroller) return;

      const dismiss = () => wrap.classList.add('is-scrolled');
      scroller.addEventListener('scroll', dismiss, { once: true, passive: true });
    });
  }
}
